// extracted by css-extract-rspack-plugin
export default {"separator":"pvuQwWOqMRIMovoN"};